// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2ySl5","approved":"Status_approved__1KdMi","rejected":"Status_rejected__1VfF0","expired":"Status_expired__3oLvX","label":"Status_label__1XZQu"};